import React from "react"
import { Box, Typography } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"
import { toneOf } from "Pages/DsRepricing/@components/tones"
import { KIND_META, iconOf, markOf } from "../@services/cellDecisions"

/**
 * The tab on the cell's top-right corner (CU-869fmm949, decision 6, UX Obs. 11-12): the icon of the most relevant
 * kind, the total when there is more than one, a dashed border and "SIM" when every decision was simulated. Outside
 * the price grid, so the cell keeps its height.
 */
export default function DecisionMark({ decisions }) {
	const mark = markOf(decisions)
	if (!mark) return null
	const tone = toneOf(KIND_META[mark.kind]?.tone)
	return <Box role="img" aria-label={mark.label} title={mark.label}
		sx={{
			position: 'absolute', top: -1, right: -1, display: 'inline-flex', alignItems: 'center', gap: 0.25,
			height: 18, px: 0.6, borderRadius: '0 8px 0 6px', backgroundColor: tone.bg, color: tone.fg,
			border: `1px ${mark.sim ? 'dashed' : 'solid'} ${tone.fg}`, pointerEvents: 'none',
		}}>
		<IconSeeker icon={iconOf(mark)} sx={{ fontSize: 10 }}/>
		{mark.total > 1 && <Typography component="span" sx={{ fontSize: 10, fontWeight: 700, lineHeight: 1 }}>{mark.total}</Typography>}
		{mark.sim && <Typography component="span" sx={{ fontSize: 9, fontWeight: 700, lineHeight: 1, ml: 0.25 }}>SIM</Typography>}
	</Box>
}
